import { OverlayTrigger } from 'react-bootstrap'
import './ContactOverlay.scss'
import { getFormatedTime } from '../../../utils/commonFunctions'
import { calculate_duration } from '../../command_center/utils'

const ContactOverlay = ({ Events }: { Events: any[] }) => {
    return (
        <div className="contact__overLay__container">
            {Events.map((event, index) => {
                const min_elevation = event?.['groundStationProperties']?.['minElevation'] || "NA"
                const bands = (event?.['bandInfo']?.['bandName'] || '').split(',') || []
                return (
                    <div className="contact__overLay__card" key={`contact-${index}`}>
                        <OverlayTrigger
                            key={`contact-${index}`}
                            placement="auto"
                            overlay={
                                <div className='contact__overLay__card__body'>
                                    <div className='d-flex w-100 align-items-center justify-content-between'>
                                        <div className='card_info'>
                                            <span className='fs-13'>{event?.['startTime'] && getFormatedTime(event?.['startTime'])} UTC</span>
                                            <span className='fs-12 opacity-50'>Start Time</span>
                                        </div>
                                        <div className='card_info align__end'>
                                            <span className='fs-13'>{event?.['startTime'] && getFormatedTime(event?.['endTime'])} UTC</span>
                                            <span className='fs-12 opacity-50'>End Time</span>
                                        </div>
                                    </div>
                                    <div className='d-flex w-100 align-items-center justify-content-between'>
                                        <div className='card_info'>
                                            <span className='fs-13'>{(event?.['endTime'] && event?.['startTime']) && `${calculate_duration((event?.['startTime']), (event?.['endTime']))}`}</span>
                                            <span className='fs-12 opacity-50'>Total Duration</span>
                                        </div>
                                        <div className='card_info align__end'>
                                            <span className='fs-13'>{min_elevation} {min_elevation !== "NA" && '\u00B0'}</span>
                                            <span className='fs-12 opacity-50'>Max. Elevation</span>
                                        </div>
                                    </div>
                                    {bands?.length > 0 &&
                                        <div className='d-flex w-100 align-items-center justify-content-between'>
                                            <div className='card_info'>
                                                <div className='d-flex gap-1 align-items-center'>
                                                    {bands.map(band => (
                                                        <div key={`band-${band}`} className={`contact__status__badge band`}>
                                                            {band.replace('-', ' ')}
                                                        </div>
                                                    ))}
                                                </div>
                                                <span className='fs-12 opacity-50'>Bands</span>
                                            </div>
                                        </div>
                                    }

                                </div>
                            }
                        >
                            <div className='contact__overLay__card__header'>
                                <div className='d-flex flex-column align-items-start w-50'>
                                    <span className='w-98 text-truncate fs-13' title={event?.['groundStationName']}>{event?.['groundStationName']}</span>
                                    <span className='fs-12 opacity-50'>Ground Station</span>
                                </div>
                                <div className='d-flex flex-column align-items-end w-50'>
                                    <span className='fs-13 text-truncate w-98 text-end' title={event?.['providerName']}>{event?.['providerName']}</span>
                                    <span className='fs-12 opacity-50'>Provider</span>
                                </div>
                            </div>
                        </OverlayTrigger>
                    </div>
                )
            })}
        </div>
    )
}

export default ContactOverlay